// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1jC8a","tab":"ProcedureTabs_tab__1SAmV"};